import { enterFullScreen } from './enterFullScreen';

/**
 * Shows the video element and begins playback.
 * Also attempts to enter full-screen mode on mobile devices.
 * @param {HTMLVideoElement} videoElement - The video element to show and play.
 * @param {HTMLElement} videoContainer - The container element for the video.
 */
export function showVideoAndPlay(videoElement, videoContainer) {
  const closeButton = document.getElementById('closeButton');
  videoElement.style.display = 'block';
  videoContainer.style.display = 'flex';
  closeButton.style.display = 'block';

  videoElement.play();

//  videoElement.play().then(() => {
//    if (window.innerWidth <= 768) {
//      enterFullScreen(videoElement);
//    }
//  });
}
